var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Checkmark_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    d: "M40 9.99775C56.5678 9.99775 69.9988 23.4302 70 39.9977C70 56.5663 56.5685 69.9977 40 69.9977C23.4318 69.9973 10 56.566 10 39.9977C10.0012 23.4305 23.4326 9.9982 40 9.99775ZM54.6777 29.9782C53.4566 28.8592 51.559 28.9432 50.4395 30.1638L37.0068 44.8073L29.3848 37.7712C28.1673 36.6477 26.2702 36.7248 25.1465 37.9421C24.0239 39.1594 24.0959 41.0568 25.3125 42.1804L35.1514 51.2624C35.737 51.803 36.5182 52.0863 37.3145 52.0534C38.11 52.0197 38.861 51.6685 39.3994 51.0817L54.8584 34.2165C55.9777 32.9954 55.8983 31.0979 54.6777 29.9782Z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#47B150"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.d4d5e6599a2ec928a4eabf8f1e265129.svg";
export { ForwardRef as ReactComponent };